import sortBy from "lodash-es/sortBy";
import {
  TrackingTrackingModelsAnalyticsDownloadDailySummary,
  TrackingApi,
  useTrackingAPI,
} from "melco-shared-logic";
import { useCallback } from "react";

type DesignsData = {
  dailySummary: TrackingTrackingModelsAnalyticsDownloadDailySummary[];
};

const initialValue = { dailySummary: [] };

export const useDesignsAnalytics = (
  startTimestamp?: Date,
  endTimestamp?: Date
) => {
  const handleRequest = useCallback(
    async (api: TrackingApi) => {
      const response = await api.analyticDailyDesignSummary({
        productCode: process.env.REACT_APP_PRODUCT_CODE!,
        startTimestamp,
        endTimestamp,
      });

      const unsortedDailySummary = response.list;

      const dailySummary = sortBy(unsortedDailySummary, "date");

      return {
        dailySummary,
      };
    },
    [startTimestamp, endTimestamp]
  );

  return useTrackingAPI<DesignsData>({
    initialValue,
    handleRequest,
  });
};
